import type { CalendarProps } from 'react-multi-date-picker';
import { Calendar } from 'react-multi-date-picker';
import styled from 'styled-components';

export const MultiDatePicker = (props: CalendarProps): JSX.Element => {
  return (
    <>
      <StyledDiv>
        <Calendar
          {...props}
          multiple
          showOtherDays
          className={'multi-date-picker'}
          weekDays={['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']}
          months={[
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
          ]}
        />
      </StyledDiv>
    </>
  );
};

const StyledDiv = styled.div`
  /* multiple date picker for timecard bulk download */
  width: fit-content;

  .rmdp-calendar {
    padding: 0px 20px 24px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .rmdp-day-picker {
      padding: 0;
    }
  }
  .rmdp-top-class {
    display: flex;
    justify-content: center;
    border: none;
  }
  .rmdp-shadow {
    box-shadow: 1px 1px 7px 1px rgb(64 64 64 / 25%) !important;
  }

  .rmdp-header {
    margin-top: 0px !important;
    border-bottom: none !important;
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    width: 100%;
  }

  .rmdp-arrow {
    border: solid #828282 !important;
    border-width: 0 1px 1px 0 !important;
  }

  .rmdp-arrow-container {
  }

  .rmdp-arrow-container:hover {
    box-shadow: none !important;
    background-color: white !important;
  }

  .rmdp-arrow-container:hover .rmdp-arrow,
  .rmdp-arrow-container.disabled .rmdp-arrow,
  .rmdp-arrow-container.disabled:hover .rmdp-arrow {
    border: solid #828282 !important;
    border-width: 0 1px 1px 0 !important;
  }

  .rmdp-day.rmdp-deactive.rmdp-selected span {
    background-color: #1733c4 !important;
    box-shadow: none;
  }

  .rmdp-day.rmdp-selected span:not(.highlight) {
    background-color: #1733c4 !important;
    box-shadow: none;
    color: #fff;
  }

  .rmdp-week-day {
    color: #202020 !important;
  }

  .rmdp-day.rmdp-deactive,
  .rmdp-day.rmdp-disabled {
    color: rgba(0, 0, 0, 0.4) !important;
  }

  .rmdp-day.rmdp-disabled span {
    background-color: #f9f9f9 !important;
    border-radius: 0px !important;
    left: 0px !important;
    right: 0px !important;
  }

  .rmdp-day.rmdp-today span {
    color: #202020 !important;
    background-color: white !important;
  }

  .rmdp-day.rmdp-today.rmdp-selected span:not(.highlight) {
    color: #fff !important;
  }

  .rmdp-everyset {
    color: #1733c4 !important;
  }

  .rmdp-day.rmdp-selected .rmdp-everyset {
    background-color: #1733c4;
    color: #fff !important;
  }

  .rmdp-day:not(.rmdp-disabled):not(.rmdp-day-hidden):not(.rmdp-selected)
    span:not(.rmdp-everyset):hover {
    background-color: #ececec !important;
    color: #000000 !important;
  }

  .rmdp-day:not(.rmdp-disabled):not(.rmdp-day-hidden):not(.rmdp-selected)
    span.rmdp-everyset:hover {
    background-color: #ececec !important;
  }

  .rmdp-border-bottom {
    border-bottom: 1px solid #d8d8d8 !important;
  }
`;
